import {
  signupConfidenceExperimentId,
} from '../experiments/signupConfidence/experiment';
import { localStorageExperimentKey } from '../experiments/constants';

export const getSignupConfidenceVariation = () => {
  const activeExperiments = JSON.parse(
    localStorage.getItem(localStorageExperimentKey),
  );

  if (!activeExperiments || !activeExperiments[signupConfidenceExperimentId]) {
    return null;
  }

  return activeExperiments[signupConfidenceExperimentId];
};
